import React from "react";
import Snapshot from "./Snapshot";
import SnapshotTable from "./SnapshotTable";
import { useState, useEffect } from "react";
import axios from "axios";
import ClientSnapshot from "./ClientSnapshot";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import RevenueSnapshot from "./RevenueSnapshot";
import AumSnapshot from "./AumSnapshot";
import { Constants } from "../../../CommonMethhods/Constants";
import Form from "react-bootstrap/Form";
import SalesSnapShot from "./SalesSnapShot";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  LoginResDecrypt,
} from "../../../CommonMethhods/CommonMethods";

function BusinessSnapshot() {
  const storeToken = localStorage.getItem("ssoToken");
  const filterTabsId = [
    "clientSnapshotYearly",
    "clientSnapshotMonthly",
    "clientSnapshotWeekly",
    "clientSnapshotYesterday",
  ];
  const [clientSnapFilter, setClientSnapFilter] = useState("yearly");
  const [revenueSnapshot, setRevenueSnapshot] = useState(null);
  const [aumSnapshot, setAumSnapshot] = useState(null);
  const [salesSnapshot, setSalesSnapshot] = useState(null);
  const [clientSnapshot, setClientSnapshot] = useState(null);
  const [chartRevenueEq, setChartRevenueEq] = useState(null);
  const [chartRevenueFno, setChartRevenueFno] = useState(null);
  const [chartRevenueTotal, setChartRevenueTotal] = useState(null);
  const [chartAumEq, setChartAumEq] = useState(null);
  const [chartAumFno, setChartAumFno] = useState(null);
  const [chartAumTotal, setChartAumTotal] = useState(null);
  const [NotTradedWMargin, setChartClientNotTradedWMargin] = useState(null);
  const [NotTradedWOMargin, setChartClientNotTradedWOMargin] = useState(null);
  const [chartClientTotal, setChartClientTotal] = useState(null);
  const [clientLoader, setClientLoader] = useState(true);
  const [loader, setLoader] = useState(true);
  const [buttonLoader, setButtonLoader] = useState({
    pdf: false,
    excel: false,
  });
  const [revenueTable, setRevenueTable] = useState({});
  const [aumTable, setAumTable] = useState({});
  const [salesTable, setSalesTable] = useState({});
  const [clientTable, setClientTable] = useState({});
  const [businessFilter, setBusinessFilter] = useState("Yearly");

  const getBuisnessSnapshotDetails = async () => {
    setLoader(true);
    let payloadValue = {
      Duration: businessFilter,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getBuisnessDetails = await axios.post(
        DASHBOARD_DEFAULT.BuisnessSnapshot_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      let res = ApiResDecrypt(getBuisnessDetails?.data);
      const responseData = res.data[0];
      setRevenueSnapshot(responseData.revenue);
      setAumSnapshot(responseData.aum);
      setSalesSnapshot(responseData.sales);
      setClientSnapshot(responseData.clients);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  // api for revenuesnapshot
  const getRevenueTableData = async (viewType = "grid") => {
    if (viewType === "pdf") {
      setButtonLoader({
        pdf: true,
      });
    }
    if (viewType === "excel") {
      setButtonLoader({
        excel: true,
      });
    }
    let payloadValue = {
      FileType: viewType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRevenueSnapshotDetails = await axios.post(
        DASHBOARD_DEFAULT.RevenueSnapshot_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getRevenueSnapshotDetails?.data);
      if (response?.status === 0) {
        if (viewType === "grid") {
          setRevenueTable(response?.data);
        } else if (viewType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(response?.message);
        }
      }

      // if (businessFilter == "Monthly") {
      //   setChartRevenueEq(response.monthly.equity.chgper);
      //   setChartRevenueFno(response.monthly.fno.chgper);
      //   setChartRevenueTotal(response.monthly.total.chgper);
      // } else if (businessFilter == "Weekly") {
      //   setChartRevenueEq(response.weekly.equity.chgper);
      //   setChartRevenueFno(response.weekly.fno.chgper);
      //   setChartRevenueTotal(response.weekly.total.chgper);
      // }
      // else if(businessFilter=="Overall"){
      // setChartRevenueEq(response.Overall.equity.chgper);
      // setChartRevenueFno(response.Overall.fno.chgper);
      // setChartRevenueTotal(response.Overall.total.chgper);
      // }
      // else {
      //   setChartRevenueEq(response.yearly.equity.chgper);
      //   setChartRevenueFno(response.yearly.fno.chgper);
      //   setChartRevenueTotal(response.yearly.total.chgper);
      // }
    } catch (error) {
      if (viewType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setButtonLoader({
        pdf: false,
        excel: false,
      });
    }
  };

  // api for aumsnapshot
  const getAUM = async (viewType = "grid") => {
    if (viewType === "pdf") {
      setButtonLoader({
        pdf: true,
      });
    }
    if (viewType === "excel") {
      setButtonLoader({
        excel: true,
      });
    }
    let payloadValue = {
      FileType: viewType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSnapshotDetails = await axios.post(
        DASHBOARD_DEFAULT.AUMSnapshot_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      let response = ApiResDecrypt(getSnapshotDetails?.data);
      // const response = getSnapshotDetails?.data;
      if (response?.status === 0) {
        if (viewType === "grid") {
          setAumTable(response?.data);
        } else if (viewType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(response?.message);
        }
      }
      // if (businessFilter == "Monthly") {
      //   setChartAumEq(response.monthly.equity.chgper);
      //   setChartAumFno(response.monthly.fno.chgper);
      //   setChartAumTotal(response.monthly.total.chgper);
      // } else if (businessFilter == "Weekly") {
      //   setChartAumEq(response.weekly.equity.chgper);
      //   setChartAumFno(response.weekly.fno.chgper);
      //   setChartAumTotal(response.weekly.total.chgper);
      // }
      // else if(businessFilter=="Overall"){
      //   setChartAumEq(response.overall.equity.chgper);
      //   setChartAumFno(response.overall.fno.chgper);
      //   setChartAumTotal(response.overall.total.chgper);
      //   }
      // else {
      //   setChartAumEq(response.yearly.equity.chgper);
      //   setChartAumFno(response.yearly.fno.chgper);
      //   setChartAumTotal(response.yearly.total.chgper);
      // }
    } catch (error) {
      console.log(error);
      if (viewType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setButtonLoader({
        pdf: false,
        excel: false,
      });
    }
  };

  //api for sales

  const getSales = async (viewType = "grid") => {
    if (viewType === "pdf") {
      setButtonLoader({
        pdf: true,
      });
    }
    if (viewType === "excel") {
      setButtonLoader({
        excel: true,
      });
    }
    let payloadValue = {
      FileType: viewType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSalesSnapshotDetails = await axios.post(
        DASHBOARD_DEFAULT.SaleSnapshot_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getSalesSnapshotDetails?.data);
      if (response?.status === 0) {
        if (viewType === "grid") {
          setSalesTable(response?.data);
        } else if (viewType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else {
          window.open(response?.data, "_self", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (viewType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setButtonLoader({
        pdf: false,
        excel: false,
      });
    }
  };

  //api for sales

  // clientSnapshot API

  const getClientSnapshotDetails = async () => {
    setClientLoader(true);
    let payloadValue = {
      duration: clientSnapFilter,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getClientSnapshotsDetails = await axios.post(
        DASHBOARD_DEFAULT.ClientSnapshot_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getClientSnapshotsDetails?.data);
      const responseData = response?.data;
      setClientTable(responseData);
      setClientLoader(false);
      setChartClientNotTradedWMargin(
        responseData.newacquiredclients.nottradedwmargin
      );
      setChartClientNotTradedWOMargin(
        responseData.newacquiredclients.nottradedwomargin
      );
    } catch (error) {
      console.log(error);
      setClientLoader(false);
    }
  };

  // useEffect(() => {
  //   getRevenueTableData();
  //   getAUM();
  // }, []);

  const handleClientSnapFilter = (data) => {
    setClientSnapFilter(data);
  };
  useEffect(() => {
    getClientSnapshotDetails();
  }, [clientSnapFilter]);

  const handleBusinessFilterChange = (e) => {
    if (e.target.value) {
      setBusinessFilter(e.target.value);
    }
  };
  const handleOnClickSnapFileType = (type, snapName) => {
    if (snapName === "Revenue") {
      getRevenueTableData(type);
    } else if (snapName === "AUM") {
      getAUM(type);
    } else if (snapName === "Sales") {
      getSales(type);
    }
  };

  useEffect(() => {
    getBuisnessSnapshotDetails();
    getRevenueTableData("grid");
    getAUM("grid");
    getSales("grid");
  }, [businessFilter]);

  return (
    <>
      <div className="card-box bottom-25">
        <div className="card-title">
          <h2>{Constants.BusinessSnapshot}</h2>
          <div className="filter-options">
            {/* <!-- dropdown --> */}
            <div className="dropdown-filter">
              <Form.Select
                size="lg"
                aria-label="Default select example"
                onChange={handleBusinessFilterChange}
              >
                <option value="Yearly">{Constants.Yearly}</option>
                <option value="Monthly">{Constants.Monthly}</option>
                <option value="Weekly">{Constants.Weekly}</option>
                <option value="Yesterday">{Constants.Yesterday}</option>

                {/* <option value="Overall">Overall</option> */}
              </Form.Select>
            </div>
          </div>
        </div>
        {/* <!-- Revenue Tab CSS --> */}
        <div
          className="accordion accordion-flush revenue-accordian"
          id="accordionFlushExample"
        >
          <div className="accordion-item">
            <div className="row">
              <Snapshot
                title="Revenue Snapshot"
                dataTarget="#flush-collapseOne"
                businessFilter={businessFilter}
                textfield={"Figures in Lacs & showing for Current"}
                snapshotData={
                  revenueSnapshot === null || undefined ? true : revenueSnapshot
                }
                isActive={true}
                loader={loader}
                chartEq={
                  chartRevenueEq === undefined || null ? true : chartRevenueEq
                }
                chartFno={
                  chartRevenueFno === undefined || null ? true : chartRevenueFno
                }
                chartTotal={
                  chartRevenueTotal === undefined || null
                    ? true
                    : chartRevenueTotal
                }
                ChartName1="Equity"
                ChartName2="Future and Option"
                titleForGraph="Revenue"
              />
              <Snapshot
                title="AUM Snapshot"
                businessFilter={businessFilter}
                textfield={"Figures in Lacs & showing for Current"}
                dataTarget="#flush-collapseTwo"
                snapshotData={
                  aumSnapshot === null || undefined ? true : aumSnapshot
                }
                isActive={true}
                chartFno={
                  chartAumFno === undefined || null ? true : chartAumFno
                }
                chartEq={chartAumEq === undefined || null ? true : chartAumEq}
                chartTotal={
                  chartAumTotal === undefined || null ? true : chartAumTotal
                }
                loader={loader}
                ChartName1="Equity"
                ChartName2="Future and Option"
                titleForGraph="AUM"
              />
              <Snapshot
                title="Sales Snapshot"
                businessFilter={businessFilter}
                textfield={"Figures in Lacs & showing for Current"}
                dataTarget="#flush-collapseThree"
                snapshotData={
                  salesSnapshot === null || undefined ? true : salesSnapshot
                }
                // chartFno={
                //   chartAumFno === undefined || null ? true : chartAumFno
                // }
                // chartEq={chartAumEq === undefined || null ? true : chartAumEq}
                // chartTotal={
                //   chartAumTotal === undefined || null ? true : chartAumTotal
                // }
                loader={loader}
                isActive={true}
                ChartName1="Equity"
                ChartName2="Future and Option"
                titleForGraph="AUM"
              />
              <Snapshot
                title="Client Snapshot"
                businessFilter={businessFilter}
                textfield={"Number showing for Current"}
                dataTarget="#flush-collapseFour"
                snapshotData={
                  clientSnapshot === null || undefined ? true : clientSnapshot
                }
                isActive={false}
                chartEq={
                  NotTradedWMargin === undefined || null
                    ? true
                    : NotTradedWMargin
                }
                chartFno={
                  NotTradedWOMargin === undefined || null
                    ? true
                    : NotTradedWOMargin
                }
                chartTotal={
                  (NotTradedWMargin === undefined || null
                    ? true
                    : NotTradedWMargin) +
                  (NotTradedWOMargin === undefined || null
                    ? true
                    : NotTradedWOMargin)
                }
                ChartName1="Not Traded w/ Margin"
                ChartName2="Not Traded w/o Margin"
                loader={loader}
                titleForGraph="Client"
              />
            </div>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-parent="#accordionFlushExample"
            >
              <RevenueSnapshot
                title="Revenue Snapshot"
                revenueTableData={
                  revenueTable === undefined || null ? true : revenueTable
                }
                handleOnClickSnapFileType={handleOnClickSnapFileType}
                buttonLoader={buttonLoader}
              />
            </div>
            <div
              id="flush-collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingTwo"
              data-parent="#accordionFlushExample"
            >
              <AumSnapshot
                title="AUM Snapshot"
                revenueTableData={
                  aumTable === undefined || null ? true : aumTable
                }
                handleOnClickSnapFileType={handleOnClickSnapFileType}
                buttonLoader={buttonLoader}
              />
            </div>
            <div
              id="flush-collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingThree"
              data-parent="#accordionFlushExample"
            >
              <SalesSnapShot
                title="Sales Snapshot"
                revenueTableData={
                  salesTable === undefined || null ? true : salesTable
                }
                handleOnClickSnapFileType={handleOnClickSnapFileType}
                buttonLoader={buttonLoader}
              />
            </div>
            <div
              id="flush-collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFour"
              data-parent="#accordionFlushExample"
            >
              <ClientSnapshot
                loaderClient={clientLoader}
                title="Client Snapshot"
                filterTabsId={filterTabsId}
                clientTableData={clientTable}
                handleClientSnapFilter={handleClientSnapFilter}
                getClientSnapshotDetails={getClientSnapshotDetails}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BusinessSnapshot;
